<template>
  <div>
    <div v-if="input.config.description.length > 0" v-html="input.config.description"/>
    <v-dialog ref="dialog"
              v-model="modal"
              :return-value.sync="date"
              persistent
              width="290px">
      <template v-slot:activator="{ on }">
        <v-text-field v-model="date"
                      outlined
                      :label="input.label"
                      prepend-icon="event"
                      readonly
                      v-on="on"></v-text-field>
      </template>
      <v-date-picker v-model="date"
                     scrollable>
        <div class="flex-grow-1"></div>
        <v-btn text
               color="primary"
               @click="modal = false">Cancel
        </v-btn>
        <v-btn text
               color="primary"
               @click="validate(date)">OK
        </v-btn>
      </v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
  import IriadeFormBlockMixin from './IriadeFormBlockMixin'

  export default {
    mixins: [IriadeFormBlockMixin],

    data: () => ({
      date: null,
      modal: false,
    }),

    methods: {
      validate(date) {
        this.$refs.dialog.save(date);
        this.$emit('input', date)
      }
    }
  }
</script>
